import { isAxiosError } from 'axios';

/**
 * Message d'erreur à montrer à l'utilisateur, tiré de la réponse de l'API.
 *
 * L'API renvoie systématiquement un `message` explicite et déjà rédigé en
 * français (voir `middleware/errorHandler.ts`) : « Compte temporairement
 * verrouillé après plusieurs échecs de connexion », « Mot de passe actuel
 * incorrect »… Les écrans l'écrasaient par un texte générique du type
 * « Identifiant ou mot de passe incorrect », ce qui envoyait l'utilisateur
 * chercher une faute de frappe alors que son compte était verrouillé.
 *
 * `secours` ne sert donc qu'aux cas sans réponse exploitable : coupure
 * réseau, API injoignable, erreur inattendue.
 */
export function messageErreurApi(error: unknown, secours: string): string {
  if (isAxiosError(error)) {
    const data = error.response?.data as { message?: unknown } | undefined;
    if (typeof data?.message === 'string' && data.message.trim().length > 0) {
      return data.message;
    }
    // Pas de réponse du tout : le serveur n'a pas été joint.
    if (!error.response) {
      return "Le serveur est injoignable. Vérifiez votre connexion réseau, puis réessayez.";
    }
  }
  return secours;
}

/** Code applicatif de l'erreur (`ACCOUNT_LOCKED`, `VALIDATION_ERROR`…), si présent. */
export function codeErreurApi(error: unknown): string | null {
  if (!isAxiosError(error)) return null;
  const data = error.response?.data as { code?: unknown } | undefined;
  return typeof data?.code === 'string' ? data.code : null;
}
